// extracted by mini-css-extract-plugin
module.exports = {"form_div":"App_form_div__2Vl00","denomination_div":"App_denomination_div__F8OKh"};